














import { Component, Prop, Vue } from 'vue-property-decorator';
import { BillTypes, getBillTypes } from '@/enums/billTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

@Component({})
export default class BillTypeRadioGroup extends Vue {
  public getBillTypes = getBillTypes;

  @Prop({ type: Number, required: true })
  public value!: BillTypes;

  @Prop({ type: String, default: '' })
  public size!: string;

  @Prop({ type: Boolean, default: true })
  public includeNone!: boolean;

  @Prop({ type: String, default: '未指定' })
  public noneText!: string;

  @Prop({ type: String, default: '' })
  public fill!: string;

  @Prop({ type: Number, default: false })
  public collectionAgency!: CollectionAgencyTypes;

  get localValue() {
    return this.value;
  }
  set localValue(value: BillTypes) {
    this.$emit('input', value);
  }

  get isPaypal() {
    switch (this.collectionAgency) {
      case CollectionAgencyTypes.PayPalAndCramSchool:
      case CollectionAgencyTypes.PayPalAndOther:
        return true;
      default:
        return false;
    }
  }

  get isUnivapay() {
    switch (this.collectionAgency) {
      case CollectionAgencyTypes.UnivaPay:
        return true;
      default:
        return false;
    }
  }

  get billTypes() {
    return getBillTypes(this.includeNone)
      .filter((item) => item !== BillTypes.MessageLink || this.isUnivapay);
  }
}
